import React, {useEffect, useRef, useState} from 'react';
import makeStyles from "@material-ui/core/styles/makeStyles";
import {useFormikContext} from "formik";

const useStyle = makeStyles((theme) => ({
    uploadRectangle: {
        borderStyle: "dashed",
        borderWidth: "1px",
        borderColor: "#9A9A9A",
        borderRadius: "10px",
        height: "200px",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "200px",
        overflow: "hidden",
        textAlign: "center"
    },
    btnUpload: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "16px",
        backgroundColor: "#BB0D66",
        marginTop: "20px",
        border: "solid #BB0D66 0px",
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
}))

const fileToDataUri = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
        resolve(event.target.result)
    };
    reader.readAsDataURL(file);
})

function LogoUploader(props) {
    const classes = useStyle();
    const handleOpenAlert = props.handleOpenAlert;
    const affinityName = props.affinityName;
    const [affinityImage, setAffinityImage] = useState(props.defaultImage !== null ? props.defaultImage : "");
    const hiddenFileInput = useRef(null);
    const {setFieldValue} = useFormikContext();


    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file)
            fileReader.onload = () => {
                resolve(fileReader.result);
            }
            fileReader.onerror = (error) => {
                reject(error);
            }
        })
    }

    const getBase64FromUrl = async (url) => {
        const data = await fetch(url, {
            mode: 'cors',
        });
        const blob = await data.blob();
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = function () {
                const base64data = reader.result;
                resolve(base64data);
            }
        });
    }

    async function onChange(file) {
        fileToDataUri(file).then(afImg => {
            setAffinityImage(afImg)
        })
        const base64 = await convertBase64(file)
        setFieldValue('company_logo', base64)
    }

    const handleClickInput = (e) => {
        if(props.defaultImage !== null){
            hiddenFileInput.current.click()
        } else if(affinityName!==null){
            hiddenFileInput.current.click()
        } else {
            handleOpenAlert("Por favor, primero ingrese el nombre de la afinidad")
        }
    };

    useEffect(() => {
        if (props.defaultImage) {
            getBase64FromUrl(props.defaultImage).then(dataUrl => {
                setFieldValue('company_logo', dataUrl)
            })
        }
    },  [])

    return (
        <React.Fragment>
            <div>

                <div
                    className={classes.uploadRectangle}
                    onClick={handleClickInput}
                >
                    {affinityImage === ''
                        ? <>
                            <p>Logo</p>
                            <p>Click para buscar el archivo</p>
                        </>
                        : <img width="200" height="200" style={{objectFit: 'contain'}} src={affinityImage}/>
                    }

                    <input
                        type="file"
                        name={props.name}
                        onChange={event => onChange(event.currentTarget.files[0])}
                        accept="image/png, image/jpeg"
                        style={{display: "none"}}
                        ref={hiddenFileInput}
                    /></div>
            </div>
        </React.Fragment>
    );
}

export default LogoUploader;